import React from "react";
import logo from "../../../assets/images/JustAct_Logo_TM_V4-01.png";
import styled from "styled-components";
import useCalendar from "../../../hooks/useCalender";
import dayjs from "dayjs";

export default function CalendarHeader() {
  const { monthIndex, setMonthIndex } = useCalendar();

  function handlePrevMonth() {
    setMonthIndex(monthIndex - 1);
  }

  function handleNextMonth() {
    setMonthIndex(monthIndex + 1);
  }

  function handleReset() {
    setMonthIndex(
      monthIndex === dayjs().month()
        ? monthIndex + Math.random()
        : dayjs().month(),
    );
  }

  return (
    <HeaderContainer>
      <LeftSection>
        <LogoContainer>
          <Image src={logo} alt="Logo" />
        </LogoContainer>
        <TitleSection>
          <MainTitle>Daily Cause List</MainTitle>
          <Subtitle>Case Management Calendar</Subtitle>
        </TitleSection>
      </LeftSection>

      <RightSection>
        <TodayButton onClick={handleReset}>Today</TodayButton>

        <NavigationGroup>
          <NavButton onClick={handlePrevMonth}>
            <Icon>chevron_left</Icon>
          </NavButton>
          <MonthDisplay>
            {dayjs(new Date(dayjs().year(), monthIndex)).format("MMMM YYYY")}
          </MonthDisplay>
          <NavButton onClick={handleNextMonth}>
            <Icon>chevron_right</Icon>
          </NavButton>
        </NavigationGroup>
      </RightSection>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 45px;
  margin-left: 45px;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #e1e3ee 0%, #e1e3ee 100%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  border-radius: 10px;
  border: 1px solid #00838c;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const LogoContainer = styled.div`
  background: white;
  padding: 0.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  display: block;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const MainTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-family: openSans-SemiBold, sans-serif;
  color: #293461;
  letter-spacing: 0.5px;
`;

const Subtitle = styled.span`
  font-size: 0.875rem;
  font-family: openSans-Regular, sans-serif;
  color: #293461;
  letter-spacing: 0.3px;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

const TodayButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #00838c;
  color: white;
  border: none;
  border-radius: 8px;
  font-family: openSans-SemiBold, sans-serif;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 131, 140, 0.3);

  .icon {
    font-family: "Material Icons";
    font-size: 1.25rem;
  }

  &:hover {
    background: #00838c;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 131, 140, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const NavigationGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.5rem 1rem;
  border-radius: 10px;
  backdrop-filter: blur(10px);
`;

const NavButton = styled.button`
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 6px;
  padding: 0.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const Icon = styled.span`
  font-family: "Material Icons";
  font-size: 1.5rem;
  color: #293461;
  display: block;
  line-height: 1;
`;

const MonthDisplay = styled.h2`
  margin: 0;
  font-size: 1.125rem;
  font-family: openSans-SemiBold, sans-serif;
  color: #293461;
  min-width: 150px;
  text-align: center;
  letter-spacing: 0.5px;
`;
